module.exports = __webpack_public_path__ + "img/zhang.e4113bee.png";